import { useQuery } from '@tanstack/react-query'
import { getMarketCaps } from 'services/marketCap'

export const QUERY_KEY = 'marketCaps'

function useMarketCapsQuery(options = {}) {
  return useQuery({
    queryKey: [QUERY_KEY],
    queryFn: getMarketCaps,
    throwOnError: true,
    staleTime: Infinity,
    gcTime: Infinity,
    ...options,
  })
}

export default useMarketCapsQuery
